import { Core } from "@faire/design-tokens";
import { pageMaxWidthCss } from "@faire/help-center/components/Mixin";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { Anchor } from "@faire/web--source/ui/LinkAnchor";
import React from "react";
import styled from "styled-components";

import { policyLinks } from "./footerContent";

export const PolicyLinks: React.FC = () => {
  const { isMobile } = useViewport();
  const { strictLocalize } = useStrictLocalization();
  const linkVariant = isMobile ? "labelSansRegular" : "paragraphSansRegular";
  return (
    <PolicyLinksWrapper>
      {policyLinks(strictLocalize).map((link, index) => (
        <React.Fragment key={link.path}>
          {index === 0 ? null : <PolicyLinkSeparator />}
          <PolicyLink href={link.path}>
            <Typography variant={linkVariant}>{link.text}</Typography>
          </PolicyLink>
        </React.Fragment>
      ))}
    </PolicyLinksWrapper>
  );
};

const PolicyLinksWrapper = styled.div`
  display: flex;

  ${responsiveMediaQueries.mobile} {
    padding: 0 24px 24px;
    flex-wrap: wrap;
    gap: ${getSpacing("1x")};
  }

  ${responsiveMediaQueries.tabletAndAbove} {
    padding: 20px 56px;
    flex-direction: row;
    flex-wrap: nowrap;
    gap: ${getSpacing("2x")};
  }

  ${responsiveMediaQueries.desktopAndAbove} {
    gap: ${getSpacing("3x")};
  }

  ${pageMaxWidthCss}
`;

const PolicyLinkSeparator = styled.span`
  display: block;
  width: 1px;
  background: ${Core.border.muted};
`;

const PolicyLink = styled(Anchor)`
  ${responsiveMediaQueries.tabletAndAbove} {
    white-space: nowrap;
  }

  > p {
    color: ${Core.text.subdued};
  }

  &:hover > p {
    color: ${Core.text.hover};
  }
`;
